"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFilterOperation = exports.TableColumnAlign = void 0;
var TableColumnAlign;
(function (TableColumnAlign) {
    TableColumnAlign["LEFT"] = "LEFT";
    TableColumnAlign["RIGHT"] = "RIGHT";
    TableColumnAlign["CENTER"] = "CENTER";
})(TableColumnAlign = exports.TableColumnAlign || (exports.TableColumnAlign = {}));
/**
 * Filter operation.
 */
var TableFilterOperation;
(function (TableFilterOperation) {
    TableFilterOperation["EQ"] = "EQ";
    TableFilterOperation["START_WITH"] = "START_WITH";
    TableFilterOperation["END_WITH"] = "END_WITH";
    TableFilterOperation["CONTAINS"] = "CONTAINS";
    TableFilterOperation["NOT_NULL"] = "NOT_NULL";
    TableFilterOperation["IS_NULL"] = "IS_NULL";
    TableFilterOperation["GT"] = "GT";
    TableFilterOperation["LT"] = "LT";
    TableFilterOperation["GTE"] = "GTE";
    TableFilterOperation["LTE"] = "LTE";
    TableFilterOperation["FTX"] = "FTX";
    TableFilterOperation["FTXF"] = "FTXF";
    TableFilterOperation["OR"] = "OR";
    TableFilterOperation["AND"] = "AND";
})(TableFilterOperation = exports.TableFilterOperation || (exports.TableFilterOperation = {}));
//# sourceMappingURL=table-types.js.map